import { html } from '@design.estate/dees-element';
import type { IHarnessSessionMeta } from '../interfaces.js';

const demoSessions: IHarnessSessionMeta[] = Array.from({ length: 24 }, (_, index) => ({
  id: `session-${index}`,
  title: [
    'Fix sitemap cache key',
    'Investigate 429s from model endpoint',
    'Refactor workbench layout',
    'Add diff support to codebox',
    'Release 3.91.0',
    'Migrate agent chat to harness group',
  ][index % 6],
  createdAt: Date.now() - (index + 2) * 3_600_000,
  updatedAt: Date.now() - (index + 1) * 3_500_000,
  messageCount: 4 + (index % 9),
  preview: 'Latest: the regression test asserts the cache key stays stable across…',
}));

const openModal = async () => {
  const { DeesModal } = await import('../../00group-overlay/dees-modal/dees-modal.js');
  const content = document.createElement('dees-harness-session-list');
  content.sessions = demoSessions;
  content.style.height = '420px';
  content.addEventListener('harness-session-open', (event) => {
    console.log('open session', (event as CustomEvent).detail.session);
  });
  DeesModal.createAndShow({
    heading: 'Conversations',
    content: html`${content}`,
    menuOptions: [],
  });
};

export const demoFunc = () => html`
  <style>
    .sessionDemo {
      display: grid;
      grid-template-rows: auto minmax(0, 1fr);
      gap: 12px;
      height: 480px;
      max-width: 420px;
      margin: 40px auto;
      padding: 16px;
      border-radius: var(--dees-radius-xl);
      border: 1px solid var(--dees-color-border-subtle);
      background: var(--dees-color-bg-secondary);
    }
    .sessionDemo dees-harness-session-list { min-height: 0; }
  </style>
  <div class="sessionDemo">
    <dees-button @clicked=${openModal}>Open in a DeesModal</dees-button>
    <dees-harness-session-list
      .sessions=${demoSessions}
      selectedSessionId="session-2"
      @harness-session-select=${(event: CustomEvent) => console.log('select', event.detail.session)}
    ></dees-harness-session-list>
  </div>
`;
